import { CloseButton, CloseButtonProps } from '@chakra-ui/react';
import React from 'react';

/*
 * Thin wrapper over Chakra's `CloseButton`. All visual behavior — hover bg,
 * focus halo, size — comes from the `closeButton` variant in
 * `styles/chakra/components/Button.ts` (v3's `CloseButton` has no recipe of
 * its own, see that file's header comment). Don't add inline color/hover
 * overrides here; lift them into the theme so every close-X in the app stays
 * consistent (drawer header, modal header, inline edit cards, etc.).
 */
export type MCloseButtonProps = CloseButtonProps;

const MCloseButton = React.forwardRef<HTMLButtonElement, MCloseButtonProps>(
  (props, ref) => (
    <CloseButton
      ref={ref}
      aria-label="Close"
      variant="closeButton"
      size="md"
      {...props}
    />
  ),
);

export default MCloseButton;
